import React, { useEffect } from "react";

import { Box } from "@mui/material";

import { GetUserProfileInformation } from "../../../Api/Signin/Dashboard.Api";
import { ReactComponent as Logo } from "../../../Assets/Images/logo/doctore.svg";
import { useAuth } from "../../../Store/AuthContext";
import JwtDecoder from "../../../Utils/JwtDecoder/JwtDecoder";

export const NavigationContentDashboard = ({ open, toggleDrawer }) => {
  const { state, dispatch } = useAuth();

  const loadUserProfileInformation = async (email) => {
    const result = await GetUserProfileInformation(
      JwtDecoder(localStorage.getItem("doctore")).email,
    );
    if (result?.type == 0) {
      dispatch({
        type: "SET_USER_DETAILS",
        payload: {
          name: result?.data,
          email: JwtDecoder(localStorage.getItem("doctore")).email,
        },
      });
    }
  };

  useEffect(() => {
    if (!state?.fullName) {
      loadUserProfileInformation(state?.user?.email);
    }
  }, [state?.fullName]);

  return (
    <>
      <Box sx={{ flexGrow: 1, marginLeft: "4px" }}>
        <Logo height={35} width={200}/>
      </Box>
    </>
  );
};
